import { ControlInterface } from 'edocatbase/Form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { Dispatch } from 'redux';
const { toggleModal } = window.Edocat.Components.ModalTest.actions;
const { Table, TableBody, TableCell, TableHead, TableRow, Fab } = window.Material;
const { Add } = window.MaterialIcons;

interface TableProps extends ControlInterface, ReduxComponentInterface {
  multiline: boolean;
  formInstanceId: string;
  formModal: any;
  index: number;
  view: boolean;
}

class ContactsTable extends React.PureComponent<TableProps> {
  handleContacts = () => {
    const { actions, formInstanceId } = this.props;
    actions.toggleModal(true, 'newContactModal', null, formInstanceId);
  };
  render() {
    const { index, value, view } = this.props;
    return (
      <Table>
        {!view && (
          <caption>
            <Fab onClick={this.handleContacts} size="small" color="primary" aria-label={'Přidat nový kontakt'}>
              <Add />
            </Fab>
          </caption>
        )}
        <TableHead>
          <TableRow>
            <TableCell>{window.Alfresco.messages.global['label.companyname']}</TableCell>
            <TableCell>{window.Alfresco.messages.global['label.companytelephone']}</TableCell>
            <TableCell>{window.Alfresco.messages.global['button.view.email']}</TableCell>
            <TableCell>Poznámka</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {value?.[index]?.contacts.length > 0 &&
            value?.[index]?.contacts.map((it: any, index: number) => (
              <TableRow key={index}>
                <TableCell>{it?.name}</TableCell>
                <TableCell>{it?.phone}</TableCell>
                <TableCell>{it?.email}</TableCell>
                <TableCell>{it?.note}</TableCell>
              </TableRow>
            ))}
          {value?.[index]?.contacts.length === 0 && (
            <TableRow>
              <TableCell colSpan={4}>{window.Alfresco.messages.global['edocat.fake-admin.table.no-results']}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: window.redux.bindActionCreators({ toggleModal }, dispatch),
});

export default window.reactRedux.connect(null, mapDispatchToProps)(ContactsTable);
